import { ICommandData, IPresentationData } from '@tencent/slide-sdk-model';
import { IChunksGenerator } from './chunks-generator.interface';

export const enum SlideInitialDataType {
    OldPresentationData = 1,
    OldPresentationChunkData,
    CommandData,
    CommandChunkData,
    PresentationData,
}

/**
 * Slide 初始数据，用来初始化 SlideAppService
 */
export type ISlideInitialData =
    | {
        type: SlideInitialDataType.OldPresentationData;
        data: string;
    }
    | {
        type: SlideInitialDataType.OldPresentationChunkData;
        data: {
            head: string;
            chunks: IChunksGenerator<string>;
        };
    }
    | {
        type: SlideInitialDataType.CommandData;
        data: ICommandData;
    }
    | {
        type: SlideInitialDataType.CommandChunkData;
        data: {
            head: ICommandData;
            chunks: IChunksGenerator<{
                commands: ICommandData[]
            }>;
        };
    }
    |  {
        type: SlideInitialDataType.PresentationData;
        data: IPresentationData;
    };

/**
 * Slide 初始数据服务
 */
export interface ISlideInitialDataService {
    /**
     * 获取初始数据，只允许执行一次，获取后，内存中将清除初始数据。
     */
    consume(): ISlideInitialData;

    /**
     * 设置初始数据
     */
    setData(data: ISlideInitialData): void;
}
